// Error types
export const ERROR_TYPES = {
    VALIDATION: 'VALIDATION',
    API: 'API',
    NETWORK: 'NETWORK',
    RUNTIME: 'RUNTIME',
    UNKNOWN: 'UNKNOWN'
};

// HTTP status codes
export const HTTP_STATUS = {
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    UNPROCESSABLE_ENTITY: 422,
    INTERNAL_SERVER_ERROR: 500,
    SERVICE_UNAVAILABLE: 503
};

// Error messages
export const ERROR_MESSAGES = {
    // Validation errors
    INVALID_ENTRY_PRICE: 'Entry price must be greater than 0',
    INVALID_STOP_LOSS: 'Stop loss must be greater than 0',
    INVALID_RISK: 'Risk must be greater than 0',
    INVALID_ACCOUNT_BALANCE: 'Account balance must be greater than 0',
    INVALID_RR: 'Risk/Reward ratio must be greater than 0',
    INVALID_LEVERAGE: 'Leverage must be greater than 0',
    INVALID_FEE: 'Fee must be greater than or equal to 0',
    INVALID_MARGIN: 'Margin must be greater than 0',
    EQUAL_ENTRY_STOP: 'Entry price cannot equal stop loss',

    // API errors
    API_ERROR: 'An error occurred while processing your request',
    NETWORK_ERROR: 'Unable to connect to the server',
    RATE_LIMIT: 'Too many requests, please try again later',

    // Runtime errors
    CALCULATION_ERROR: 'Error during calculation',
    UNKNOWN_ERROR: 'An unexpected error occurred'
};

// Error severities
export const ERROR_SEVERITY = {
    INFO: 'info',
    WARNING: 'warning',
    ERROR: 'error',
    CRITICAL: 'critical'
};